import { IntlShape } from 'react-intl'
import { create, enforce, group, omitWhen, test } from 'vest'
import {
  ProgressiveDiscount,
  ProgressiveDiscountTrigger,
} from '../../../../../../typings'
import messages from '../messages'

export const name = ProgressiveDiscount.Trigger

export function validationSuite(intl: IntlShape) {
  return create(({ collections, skus }: ProgressiveDiscountTrigger) => {
    const { $t } = intl
    const { validation } = messages

    group('trigger', () => {
      omitWhen(collections.length > 0 || skus.length > 0, () => {
        test(`${name}.skus`, $t(validation.itemsRequired), () => {
          enforce(skus.length).gt(0)
        })

        test(`${name}.collections`, $t(validation.itemsRequired), () => {
          enforce(collections.length).gt(0)
        })
      })
    })
  })
}
